// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"cef1ee17","605":"ce4fa0e4","809":"62452d41","981":"d5c9b19e"}[chunkId] + ".chunk.js";
};